import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { InquiryComponent } from './inquiry.component';

@NgModule({
  declarations: [InquiryComponent],
  imports: [SharedModule.forRoot()],
  exports: [InquiryComponent],
})
export class InquiryModule {}
